import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Functional } from 'vms-base';

import s from './MapNoteSheet.module.scss';

const MapNoteType = props => {
    const splitWords = props.noteType.replace(/([a-z])([A-Z])/g, '$1 $2');
    const label = Functional.capitalizeFirst(splitWords);
    return (
        <div className={s.noteType}>
            <div className={classNames(s.label, s[props.noteType])}>{label}</div>
        </div>
    );
};

MapNoteType.propTypes = { noteType: PropTypes.string.isRequired };

export default MapNoteType;
